import React,{useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import FormControl from '@material-ui/core/FormControl';
import { green, pink } from '@material-ui/core/colors';
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Button from '@material-ui/core/Button';
// import {AuthData} from '../Services/Authdata';
import {AdminLogin} from '../Services/AdminLogin';
import { useHistory } from "react-router-dom";




const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        // backgroundColor: green[500],
      },
      paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      },
      pink: {
        color: theme.palette.getContrastText(pink[500]),
        backgroundColor: pink[500],
        margin:'auto'
      },
      green: {
        color: '#fff',
        backgroundColor: green[500],
      },
    }));

  export default function Login() {
    let history = useHistory()
    const classes = useStyles();
    const [loader, setLoader] = useState("")
    const [email, setEmail] = useState("");
    const [loginMessage, setLoginMessage] = useState('');
    const [password, setPassword] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [action, setAction] = useState(false);
    const [emailMessage, setEmailMessage] = useState("")
    const submitForm = (e)=>{
      e.preventDefault();
      setLoader(<CircularProgress color="secondary" style={{'position':'absolute',marginTop:'2%'}}/>)
      setAction(true)
      setTimeout(function(){
        setLoader("");
        if(email === ""){
          setEmailError(true)
          setEmailMessage('Required Valid Email Id');
        }else{
          setEmailError(false)
          setEmailMessage('');
        }
        const userData = {'email':email,'password':password};
        AdminLogin('post','admin/login',userData).then((result)=>{
         // console.log(result);
          if(result.status === 1){
            window.sessionStorage.setItem("userData", JSON.stringify(result.data));
            localStorage.setItem("userData", JSON.stringify(result.data));
            localStorage.setItem("com",JSON.stringify(result.data.com))
            setLoginMessage(<Alert variant="outlined" severity="success">
                                {result.message}
                              </Alert>);
            setTimeout(function(){
              history.push('/');
              // return <Redirect to={'/'} />
            },500)
          }else{
            setAction(false)
            setLoginMessage(<Alert variant="outlined" severity="error">
                                {result.message}
                              </Alert>);
          }
        })
      },2000)
      
    }
    // if(AuthData() != null){
    //   return <Redirect to={'/'} />
    // }
    return (
        <div className={classes.root}>
          <Grid container spacing={3} item xs={4} style={{margin:'auto',marginTop:"5%"}}>
              <Grid item xs>
                <Paper className={classes.paper} elevation={5}>
                <Avatar className={classes.pink}>
                  <PersonIcon />
                </Avatar>
                <h3>Login</h3>
                
              {loginMessage}
              <br></br>
              {loader}
                  <form onSubmit={submitForm}>
                  <FormControl style={{width:'100%',marginBottom:"5px"}}>
                      <TextField
                      error={emailError}
                      helperText={emailMessage} 
                      type="email"
                      required
                      id="outlined-basic"
                      label="Email"
                      variant="outlined"
                      onChange={e => setEmail(e.target.value)} />
                  </FormControl>
                  <FormControl style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                      <TextField 
                      id="outlined-basic"
                      label="Password"
                      variant="outlined"
                      type="password" 
                      required
                      onChange={e => setPassword(e.target.value)}/>
                  </FormControl>
                  <FormControl style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                        name="checkedI"
                      />
                    }
                    label="Remember Me"
                  />
                  </FormControl>
                  
                  <FormControl style={{marginBottom:"5px"}}>
                  <Button type="submit" disabled={action} variant="contained" color="primary" disableElevation>
                    Login
                  </Button>
                  </FormControl>
                  </form>
                </Paper>
              </Grid>
          </Grid>
    
        </div>
      );
  }


// WEBPACK FOOTER //
// ./src/Pages/Login.js